var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{attrs:{"plain":"","hairline":"","type":"info","native-type":"button","size":"small","loading":_vm.sending,"loading-text":"发送中...","disabled":_vm.send},on:{"click":_vm.handleSendSms}},[_vm._v(_vm._s(_vm.buttonText))])}
var staticRenderFns = []

export { render, staticRenderFns }